import ApplicationModel from '../../../shared/models/applications/api/ApplicationModel';
import { getTelephonyDeployments } from '../../../shared/api/controllers/telephonyDeployment';

export interface LocationPhoneExportRow {
    'App Name': string;
    'Phone Numbers': string;
}

export const loadLocationPhoneExport = async (applications: ApplicationModel[]): Promise<LocationPhoneExportRow[]> => {
    const rows: LocationPhoneExportRow[] = [];
    const errors: string[] = [];
    let nextIndex = 0;

    const worker = async () => {
        while (nextIndex < applications.length) {
            const app = applications[nextIndex++];
            const name = app.name || 'Unknown Location';
            try {
                let phoneNumbers: string[] = [];
                if (!app.allowsTemplating) {
                    if (!app.id) throw new Error('Missing app ID.');
                    const result = await getTelephonyDeployments(app.id);
                    if (result.resultType !== 'Ok') {
                        throw new Error(result.errors?.join(', ') || 'Could not load phone numbers.');
                    }
                    phoneNumbers = Array.from(new Set((result.data || [])
                        .map(deployment => (deployment.phoneNumber || '').trim())
                        .filter(Boolean)));
                }
                rows.push({ 'App Name': name, 'Phone Numbers': phoneNumbers.join('; ') });
            } catch (error) {
                errors.push(`${name}: ${error.message || error.toString()}`);
            }
        }
    };

    await Promise.all(Array.from({ length: Math.min(5, applications.length) }, worker));
    if (errors.length > 0) {
        throw new Error(`Could not export all app phone numbers. ${errors.join(' ')}`);
    }
    return rows.sort((a, b) => a['App Name'].localeCompare(b['App Name']));
};
